import React from "react";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const SystemConfigHeader = ({ t, currentModeLabel }) => (
  <>
    <header className="system-config-header">
      <div className="system-config-title-mark">
        <SettingsSuggestIcon />
      </div>
      <div>
        <p className="system-config-eyebrow">{t.superControls}</p>
        <h2>{t.title}</h2>
        <p>{t.description}</p>
      </div>
    </header>

    <section className="system-config-status">
      <div>
        <span>{t.activeHealthReport}</span>
        <strong>{currentModeLabel}</strong>
      </div>
      <CheckCircleIcon />
    </section>
  </>
);

export default SystemConfigHeader;
